import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import { distinctUntilChanged, map } from 'rxjs';
import { ClassStudentStoreModel, ClassStudentUIModel } from './class-student.model';
import { ClassStudentState, ClassStudentStore } from './class-student.store';

@Injectable({ providedIn: 'root' })
export class ClassStudentQuery extends QueryEntity<
  ClassStudentState,
  ClassStudentStoreModel,
  ClassStudentUIModel,
  'id'
> {
  constructor(protected override readonly store: ClassStudentStore) {
    super(store);
  }

  readonly isEmpty$ = this.entities$.pipe(
    map((entities) => entities.length === 0),
    distinctUntilChanged(),
  );

  override readonly toUIModelFn = (entity: ClassStudentStoreModel): ClassStudentUIModel => {
    const fullName = [entity.first_name, entity.last_name].filter(Boolean).join(' ') || entity.email || '';
    return {
      ...entity,
      studentId: entity.student_id!,
      classId: entity.class_id!,
      joinedAt: entity.joined_at!,
      firstName: entity.first_name,
      lastName: entity.last_name,
      profilePic: entity.profile_pic,
      fullName,
    };
  };

  getByClassId(classId: string): ClassStudentUIModel[] {
    return this.getAllUIEntities().filter((e) => e.classId === classId);
  }

  selectUIEntitiesByStudentIds(studentIds: string[]) {
    const idSet = new Set(studentIds);
    return this.entities$.pipe(map((entities) => entities.filter((e) => idSet.has(e.studentId))));
  }
}
